import { useRef } from 'react';

import { StyledEditable } from './content-editable.style';

type EditableProps = {
  placeholder?: string;
  disabled?: boolean;
  onChange: (e: {
    target: {
      value: string;
    };
  }) => void;
  onFocus?: (e: React.SyntheticEvent<any>) => void;
  onBlur?: (e: React.SyntheticEvent<any>) => void;
  html: string;
};

const ContentEditable = ({
  placeholder,
  disabled = false,
  onChange,
  onFocus,
  onBlur,
  html
}: EditableProps) => {
  let lastHtml = html;
  const elem = useRef<HTMLSpanElement>();
  const getEl = () => elem.current;
  const min = 1;
  const max = 100;

  const emitChange = (originalEvt: React.SyntheticEvent<HTMLSpanElement>) => {
    const el = getEl();
    if (!el) return;
    const innerHTML = el.innerText;
    if (onChange && innerHTML !== lastHtml) {

      const evt = Object.assign({}, originalEvt, {
        target: {
          value: Math.max(min, Math.min(max, Number(innerHTML))).toString()
        }
      });
      onChange(evt);
    }
    lastHtml = innerHTML;
  };

  const validate = (event: React.KeyboardEvent<HTMLElement>) => {
    const keyCode = event.keyCode || event.which;
    const string = String.fromCharCode(keyCode);
    // if (event.currentTarget.innerHTML.length > 2) {
    //   event.preventDefault();
    // }

    if (!/[0-9]/.test(string)) {
      event.preventDefault();
    }
  };

  const props = {
    ref: elem,
    placeholder,
    onInput: emitChange,
    onKeyPress: validate,
    onBlur: onBlur || undefined,
    onFocus: onFocus || undefined,
    contentEditable: !disabled,
    html: html
  } as React.HTMLAttributes<HTMLSpanElement>;

  return <StyledEditable {...props} />;
};

export default ContentEditable;
